/**
 * @generated SignedSource<<855c2fb5d60de6b2f2a33107a6880b67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoDetailContent_todo$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TVTodoPopovers_todo" | "TodoContact_todo" | "TodoDetailContentMain_todo" | "TodoDetailImages_todo" | "TodoDetailSubTodos_todo" | "TodoDetailTimeline_todo" | "TodoDetailToolbar_todo" | "TodoEditNewMainCreationInfo">;
  readonly " $fragmentType": "TodoDetailContent_todo";
};
export type TodoDetailContent_todo$key = {
  readonly " $data"?: TodoDetailContent_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoDetailContent_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoDetailContent_todo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoDetailContentMain_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoDetailToolbar_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoDetailTimeline_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TVTodoPopovers_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainCreationInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoDetailImages_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoDetailSubTodos_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoContact_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "9cbc10aafc0ae6b6ae57e38b5f8e8f78";

export default node;
